// extracted by mini-css-extract-plugin
export default {"home_blocks":"Welcome_home_blocks__Bet47","welcome_or":"Welcome_welcome_or__Vu0IZ","welcome_content":"Welcome_welcome_content__KDjFj","welcome_copy":"Welcome_welcome_copy__18GR2"};